/* FirstPartyDataChip — quiet, single-row Home-page nudge replacing the
   former full strength panel. The full panel was a dashboard-within-a-
   dashboard; it competed with the hero for attention and made the page
   feel like background noise.

   This chip surfaces ONLY:
     • Data Health score (e.g. "26%")
     • Status word ("Sparse" / "Solid" / "Signature") in band color
     • Right-arrow CTA to /data-room

   The full 12-dimension breakdown + dimension chips lives on /data-room,
   not here.

   Reads GET /api/brand/onboarding/footprint-strength.
   Fail-quiet — renders nothing on error.  */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ChevronRight, Sparkles } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const BAND_STYLES = {
  sparse:    { color: '#EF4444', label: 'Sparse',    glow: 'rgba(239,68,68,0.08)' },
  solid:     { color: '#F59E0B', label: 'Solid',     glow: 'rgba(245,158,11,0.08)' },
  signature: { color: '#4ADE80', label: 'Signature', glow: 'rgba(74,222,128,0.08)' },
};

export default function FirstPartyDataChip() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/api/brand/onboarding/footprint-strength`, { withCredentials: true })
      .then(r => { if (!cancelled) setData(r.data); })
      .catch(() => { if (!cancelled) setErr(true); });
    return () => { cancelled = true; };
  }, []);

  if (err || !data) return null;

  const band = BAND_STYLES[data.band] || BAND_STYLES.solid;

  return (
    <Link
      to="/data-room"
      data-testid="first-party-data-chip"
      data-band={data.band}
      data-score={data.score}
      className="flex items-center justify-between gap-3 rounded-xl px-4 py-2.5 hover:brightness-110 transition-all"
      style={{
        background: band.glow,
        border: '1px solid rgba(255,255,255,0.06)',
      }}
    >
      <div className="flex items-center gap-3 min-w-0">
        <span className="text-[10px] uppercase tracking-[0.18em] text-gray-500 font-bold whitespace-nowrap">Data health</span>
        <span className="text-lg font-black tabular-nums" style={{ color: band.color }}>{data.score}%</span>
        <span className="text-[11px] font-bold uppercase tracking-wider" style={{ color: band.color }}>
          {band.label}
        </span>
        {data.band === 'signature' && <Sparkles className="h-3 w-3" style={{ color: band.color }} />}
      </div>
      <span className="text-[10px] text-gray-400 font-bold flex items-center gap-0.5 whitespace-nowrap">
        Open data room <ChevronRight className="h-3 w-3" />
      </span>
    </Link>
  );
}
